module.exports = __webpack_public_path__ + "static/media/haroldstenurecelebration2.88e03724.jpeg";